import { IUnreadProps } from '@/entities/Unread'

export const Types = {
  unread: 'unread',
  saving: 'saving',
  removing: 'removing',
  finished: 'finished',
  errors: 'errors',
  dialog: 'dialog',
  none: 'none'
}

export const path = 'notification/'

export class Unread implements FluxStandardAction<IUnreadProps> {
  type = path + Types.unread
  constructor(public payload: IUnreadProps) {}
}
